(function () {
    const elements = document.querySelectorAll('.parallax-bg');
    if (!elements.length) return;

    let ticking = false;

    function updateParallax() {
        const scrollY = window.pageYOffset;

        elements.forEach((el) => {
            const section = el.closest('.choose-main-sec');

            // FIX: check if section exists
            if (!section) return;

            const rect = section.getBoundingClientRect();
            const speed = 0.25;
            const offset = rect.top * speed;

            el.style.transform =
                `translate3d(0, ${offset}px, 0)`;
        });

        ticking = false;
    }

    function onScroll() {
        if (!ticking) {
            requestAnimationFrame(updateParallax);
            ticking = true;
        }
    }

    window.addEventListener('scroll', onScroll);
    updateParallax();
})();

/******* 27-04-2026 *******/ 
$(document).ready(function(){
    $('.cstm-content-coll').hide();
    $('.cstm-heading-coll').on('click', function (e) {
        e.preventDefault();
        var parent = $(this).closest('.cstm-heading-coll-item');
        parent.find('.cstm-content-coll').stop(true, true).slideToggle();
        parent.toggleClass('active');
    });
});